/* tslint:disable */
/* eslint-disable */
/**
 * Cushla API
 * REST API for Cushla
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import {Specialization} from './specialization'

/**
 *
 * @export
 * @interface CreatePatientFacilityDto
 */
export interface CreatePatientFacilityDto {
  /**
   * If null, will be converted to empty string.
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  addressLine?: string
  /**
   * If null, will be converted to empty string.
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  city?: string
  /**
   * If null, will be converted to empty string.
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  country?: string
  /**
   * If null, will be converted to empty string.
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  county?: string
  /**
   *
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  email?: string
  /**
   * The name of the facility. Facilities can\'t have too short names (like \'a\', \'bb\', etc.)
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  phoneNumber?: string
  /**
   *
   * @type {Array<Specialization>}
   * @memberof CreatePatientFacilityDto
   */
  specializations: Array<Specialization>
  /**
   * Time zone where the facility is located
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  timeZone: CreatePatientFacilityDtoTimeZoneEnum
  /**
   *
   * @type {string}
   * @memberof CreatePatientFacilityDto
   */
  website?: string
}

/**
 * @export
 * @enum {string}
 */
export enum CreatePatientFacilityDtoTimeZoneEnum {
  ASIA_ADEN = 'Asia/Aden',
  AMERICA_CUIABA = 'America/Cuiaba',
  ETC_GMT9 = 'Etc/GMT+9',
  ETC_GMT8 = 'Etc/GMT+8',
  AFRICA_NAIROBI = 'Africa/Nairobi',
  AMERICA_MARIGOT = 'America/Marigot',
  ASIA_AQTAU = 'Asia/Aqtau',
  PACIFIC_KWAJALEIN = 'Pacific/Kwajalein',
  AMERICA_EL_SALVADOR = 'America/El_Salvador',
  ASIA_PONTIANAK = 'Asia/Pontianak',
  AFRICA_CAIRO = 'Africa/Cairo',
  PACIFIC_PAGO_PAGO = 'Pacific/Pago_Pago',
  AFRICA_MBABANE = 'Africa/Mbabane',
  ASIA_KUCHING = 'Asia/Kuching',
  PACIFIC_HONOLULU = 'Pacific/Honolulu',
  PACIFIC_RAROTONGA = 'Pacific/Rarotonga',
  AMERICA_GUATEMALA = 'America/Guatemala',
  AUSTRALIA_HOBART = 'Australia/Hobart',
  EUROPE_LONDON = 'Europe/London',
  AMERICA_BELIZE = 'America/Belize',
  AMERICA_PANAMA = 'America/Panama',
  ASIA_CHUNGKING = 'Asia/Chungking',
  AMERICA_MANAGUA = 'America/Managua',
  AMERICA_INDIANA_PETERSBURG = 'America/Indiana/Petersburg',
  ASIA_YEREVAN = 'Asia/Yerevan',
  EUROPE_BRUSSELS = 'Europe/Brussels',
  GMT = 'GMT',
  EUROPE_WARSAW = 'Europe/Warsaw',
  AMERICA_CHICAGO = 'America/Chicago',
  ASIA_KASHGAR = 'Asia/Kashgar',
  CHILE_CONTINENTAL = 'Chile/Continental',
  PACIFIC_YAP = 'Pacific/Yap',
  CET = 'CET',
  ETC_GMT_1 = 'Etc/GMT-1',
  ETC_GMT_0 = 'Etc/GMT-0',
  EUROPE_JERSEY = 'Europe/Jersey',
  AMERICA_TEGUCIGALPA = 'America/Tegucigalpa',
  ETC_GMT_5 = 'Etc/GMT-5',
  EUROPE_ISTANBUL = 'Europe/Istanbul',
  AMERICA_EIRUNEPE = 'America/Eirunepe',
  ETC_GMT_4 = 'Etc/GMT-4',
  AMERICA_MIQUELON = 'America/Miquelon',
  ETC_GMT_3 = 'Etc/GMT-3',
  EUROPE_LUXEMBOURG = 'Europe/Luxembourg',
  ETC_GMT_2 = 'Etc/GMT-2',
  ETC_GMT_9 = 'Etc/GMT-9',
  AMERICA_ARGENTINA_CATAMARCA = 'America/Argentina/Catamarca',
  ETC_GMT_8 = 'Etc/GMT-8',
  ETC_GMT_7 = 'Etc/GMT-7',
  ETC_GMT_6 = 'Etc/GMT-6',
  EUROPE_ZAPOROZHYE = 'Europe/Zaporozhye',
  CANADA_YUKON = 'Canada/Yukon',
  CANADA_ATLANTIC = 'Canada/Atlantic',
  ATLANTIC_ST_HELENA = 'Atlantic/St_Helena',
  AUSTRALIA_TASMANIA = 'Australia/Tasmania',
  LIBYA = 'Libya',
  EUROPE_GUERNSEY = 'Europe/Guernsey',
  AMERICA_GRAND_TURK = 'America/Grand_Turk',
  ASIA_SAMARKAND = 'Asia/Samarkand',
  AMERICA_ARGENTINA_CORDOBA = 'America/Argentina/Cordoba',
  ASIA_PHNOM_PENH = 'Asia/Phnom_Penh',
  AFRICA_KIGALI = 'Africa/Kigali',
  ASIA_ALMATY = 'Asia/Almaty',
  US_ALASKA = 'US/Alaska',
  ASIA_DUBAI = 'Asia/Dubai',
  EUROPE_ISLE_OF_MAN = 'Europe/Isle_of_Man',
  AMERICA_ARAGUAINA = 'America/Araguaina',
  CUBA = 'Cuba',
  ASIA_NOVOSIBIRSK = 'Asia/Novosibirsk',
  AMERICA_ARGENTINA_SALTA = 'America/Argentina/Salta',
  ETC_GMT3 = 'Etc/GMT+3',
  AFRICA_TUNIS = 'Africa/Tunis',
  ETC_GMT2 = 'Etc/GMT+2',
  ETC_GMT1 = 'Etc/GMT+1',
  PACIFIC_FAKAOFO = 'Pacific/Fakaofo',
  AFRICA_TRIPOLI = 'Africa/Tripoli',
  ETC_GMT0 = 'Etc/GMT+0',
  ISRAEL = 'Israel',
  AFRICA_BANJUL = 'Africa/Banjul',
  ETC_GMT7 = 'Etc/GMT+7',
  INDIAN_COMORO = 'Indian/Comoro',
  ETC_GMT6 = 'Etc/GMT+6',
  ETC_GMT5 = 'Etc/GMT+5',
  ETC_GMT4 = 'Etc/GMT+4',
  PACIFIC_PORT_MORESBY = 'Pacific/Port_Moresby',
  US_ARIZONA = 'US/Arizona',
  ANTARCTICA_SYOWA = 'Antarctica/Syowa',
  INDIAN_REUNION = 'Indian/Reunion',
  PACIFIC_PALAU = 'Pacific/Palau',
  EUROPE_KALININGRAD = 'Europe/Kaliningrad',
  AMERICA_MONTEVIDEO = 'America/Montevideo',
  AFRICA_WINDHOEK = 'Africa/Windhoek',
  ASIA_KARACHI = 'Asia/Karachi',
  AFRICA_MOGADISHU = 'Africa/Mogadishu',
  AUSTRALIA_PERTH = 'Australia/Perth',
  BRAZIL_EAST = 'Brazil/East',
  ETC_GMT = 'Etc/GMT',
  ASIA_CHITA = 'Asia/Chita',
  PACIFIC_EASTER = 'Pacific/Easter',
  ANTARCTICA_DAVIS = 'Antarctica/Davis',
  ANTARCTICA_MC_MURDO = 'Antarctica/McMurdo',
  ASIA_MACAO = 'Asia/Macao',
  AMERICA_MANAUS = 'America/Manaus',
  AFRICA_FREETOWN = 'Africa/Freetown',
  EUROPE_BUCHAREST = 'Europe/Bucharest',
  ASIA_TOMSK = 'Asia/Tomsk',
  AMERICA_ARGENTINA_MENDOZA = 'America/Argentina/Mendoza',
  ASIA_MACAU = 'Asia/Macau',
  EUROPE_MALTA = 'Europe/Malta',
  MEXICO_BAJA_SUR = 'Mexico/BajaSur',
  PACIFIC_TAHITI = 'Pacific/Tahiti',
  AFRICA_ASMERA = 'Africa/Asmera',
  EUROPE_BUSINGEN = 'Europe/Busingen',
  AMERICA_ARGENTINA_RIO_GALLEGOS = 'America/Argentina/Rio_Gallegos',
  AFRICA_MALABO = 'Africa/Malabo',
  EUROPE_SKOPJE = 'Europe/Skopje',
  AMERICA_CATAMARCA = 'America/Catamarca',
  AMERICA_GODTHAB = 'America/Godthab',
  EUROPE_SARAJEVO = 'Europe/Sarajevo',
  AUSTRALIA_ACT = 'Australia/ACT',
  GB_EIRE = 'GB-Eire',
  AFRICA_LAGOS = 'Africa/Lagos',
  AMERICA_CORDOBA = 'America/Cordoba',
  EUROPE_ROME = 'Europe/Rome',
  ASIA_DACCA = 'Asia/Dacca',
  INDIAN_MAURITIUS = 'Indian/Mauritius',
  PACIFIC_SAMOA = 'Pacific/Samoa',
  AMERICA_REGINA = 'America/Regina',
  AMERICA_FORT_WAYNE = 'America/Fort_Wayne',
  AMERICA_DAWSON_CREEK = 'America/Dawson_Creek',
  AFRICA_ALGIERS = 'Africa/Algiers',
  EUROPE_MARIEHAMN = 'Europe/Mariehamn',
  AMERICA_ST_JOHNS = 'America/St_Johns',
  AMERICA_ST_THOMAS = 'America/St_Thomas',
  EUROPE_ZURICH = 'Europe/Zurich',
  AMERICA_ANGUILLA = 'America/Anguilla',
  ASIA_DILI = 'Asia/Dili',
  AMERICA_DENVER = 'America/Denver',
  AFRICA_BAMAKO = 'Africa/Bamako',
  EUROPE_SARATOV = 'Europe/Saratov',
  GB = 'GB',
  MEXICO_GENERAL = 'Mexico/General',
  PACIFIC_WALLIS = 'Pacific/Wallis',
  EUROPE_GIBRALTAR = 'Europe/Gibraltar',
  AFRICA_CONAKRY = 'Africa/Conakry',
  AFRICA_LUBUMBASHI = 'Africa/Lubumbashi',
  ASIA_ISTANBUL = 'Asia/Istanbul',
  AMERICA_HAVANA = 'America/Havana',
  NZ_CHAT = 'NZ-CHAT',
  ASIA_CHOIBALSAN = 'Asia/Choibalsan',
  AMERICA_PORTO_ACRE = 'America/Porto_Acre',
  ASIA_OMSK = 'Asia/Omsk',
  EUROPE_VADUZ = 'Europe/Vaduz',
  US_MICHIGAN = 'US/Michigan',
  ASIA_DHAKA = 'Asia/Dhaka',
  AMERICA_BARBADOS = 'America/Barbados',
  EUROPE_TIRASPOL = 'Europe/Tiraspol',
  ATLANTIC_CAPE_VERDE = 'Atlantic/Cape_Verde',
  ASIA_YEKATERINBURG = 'Asia/Yekaterinburg',
  AMERICA_LOUISVILLE = 'America/Louisville',
  PACIFIC_JOHNSTON = 'Pacific/Johnston',
  PACIFIC_CHATHAM = 'Pacific/Chatham',
  EUROPE_LJUBLJANA = 'Europe/Ljubljana',
  AMERICA_SAO_PAULO = 'America/Sao_Paulo',
  ASIA_JAYAPURA = 'Asia/Jayapura',
  AMERICA_CURACAO = 'America/Curacao',
  ASIA_DUSHANBE = 'Asia/Dushanbe',
  AMERICA_GUYANA = 'America/Guyana',
  AMERICA_GUAYAQUIL = 'America/Guayaquil',
  AMERICA_MARTINIQUE = 'America/Martinique',
  PORTUGAL = 'Portugal',
  EUROPE_BERLIN = 'Europe/Berlin',
  EUROPE_MOSCOW = 'Europe/Moscow',
  EUROPE_CHISINAU = 'Europe/Chisinau',
  AMERICA_PUERTO_RICO = 'America/Puerto_Rico',
  AMERICA_RANKIN_INLET = 'America/Rankin_Inlet',
  PACIFIC_PONAPE = 'Pacific/Ponape',
  EUROPE_STOCKHOLM = 'Europe/Stockholm',
  EUROPE_BUDAPEST = 'Europe/Budapest',
  AMERICA_ARGENTINA_JUJUY = 'America/Argentina/Jujuy',
  AUSTRALIA_EUCLA = 'Australia/Eucla',
  ASIA_SHANGHAI = 'Asia/Shanghai',
  UNIVERSAL = 'Universal',
  EUROPE_ZAGREB = 'Europe/Zagreb',
  AMERICA_PORT_OF_SPAIN = 'America/Port_of_Spain',
  EUROPE_HELSINKI = 'Europe/Helsinki',
  ASIA_BEIRUT = 'Asia/Beirut',
  ASIA_TEL_AVIV = 'Asia/Tel_Aviv',
  PACIFIC_BOUGAINVILLE = 'Pacific/Bougainville',
  US_CENTRAL = 'US/Central',
  AFRICA_SAO_TOME = 'Africa/Sao_Tome',
  INDIAN_CHAGOS = 'Indian/Chagos',
  AMERICA_CAYENNE = 'America/Cayenne',
  ASIA_YAKUTSK = 'Asia/Yakutsk',
  PACIFIC_GALAPAGOS = 'Pacific/Galapagos',
  AUSTRALIA_NORTH = 'Australia/North',
  EUROPE_PARIS = 'Europe/Paris',
  AFRICA_NDJAMENA = 'Africa/Ndjamena',
  PACIFIC_FIJI = 'Pacific/Fiji',
  AMERICA_RAINY_RIVER = 'America/Rainy_River',
  INDIAN_MALDIVES = 'Indian/Maldives',
  AUSTRALIA_YANCOWINNA = 'Australia/Yancowinna',
  SYSTEM_V_AST4 = 'SystemV/AST4',
  ASIA_ORAL = 'Asia/Oral',
  AMERICA_YELLOWKNIFE = 'America/Yellowknife',
  PACIFIC_ENDERBURY = 'Pacific/Enderbury',
  AMERICA_JUNEAU = 'America/Juneau',
  AUSTRALIA_VICTORIA = 'Australia/Victoria',
  AMERICA_INDIANA_VEVAY = 'America/Indiana/Vevay',
  ASIA_TASHKENT = 'Asia/Tashkent',
  ASIA_JAKARTA = 'Asia/Jakarta',
  AFRICA_CEUTA = 'Africa/Ceuta',
  ASIA_BARNAUL = 'Asia/Barnaul',
  AMERICA_RECIFE = 'America/Recife',
  AMERICA_BUENOS_AIRES = 'America/Buenos_Aires',
  AMERICA_NORONHA = 'America/Noronha',
  AMERICA_SWIFT_CURRENT = 'America/Swift_Current',
  AUSTRALIA_ADELAIDE = 'Australia/Adelaide',
  AMERICA_METLAKATLA = 'America/Metlakatla',
  AFRICA_DJIBOUTI = 'Africa/Djibouti',
  AMERICA_PARAMARIBO = 'America/Paramaribo',
  ASIA_QOSTANAY = 'Asia/Qostanay',
  EUROPE_SIMFEROPOL = 'Europe/Simferopol',
  EUROPE_SOFIA = 'Europe/Sofia',
  AFRICA_NOUAKCHOTT = 'Africa/Nouakchott',
  EUROPE_PRAGUE = 'Europe/Prague',
  AMERICA_INDIANA_VINCENNES = 'America/Indiana/Vincennes',
  ANTARCTICA_MAWSON = 'Antarctica/Mawson',
  AMERICA_KRALENDIJK = 'America/Kralendijk',
  ANTARCTICA_TROLL = 'Antarctica/Troll',
  EUROPE_SAMARA = 'Europe/Samara',
  INDIAN_CHRISTMAS = 'Indian/Christmas',
  AMERICA_ANTIGUA = 'America/Antigua',
  PACIFIC_GAMBIER = 'Pacific/Gambier',
  AMERICA_INDIANAPOLIS = 'America/Indianapolis',
  AMERICA_INUVIK = 'America/Inuvik',
  AMERICA_IQALUIT = 'America/Iqaluit',
  PACIFIC_FUNAFUTI = 'Pacific/Funafuti',
  UTC = 'UTC',
  ANTARCTICA_MACQUARIE = 'Antarctica/Macquarie',
  CANADA_PACIFIC = 'Canada/Pacific',
  AMERICA_MONCTON = 'America/Moncton',
  AFRICA_GABORONE = 'Africa/Gaborone',
  PACIFIC_CHUUK = 'Pacific/Chuuk',
  ASIA_PYONGYANG = 'Asia/Pyongyang',
  AMERICA_ST_VINCENT = 'America/St_Vincent',
  ASIA_GAZA = 'Asia/Gaza',
  ETC_UNIVERSAL = 'Etc/Universal',
  PST8_PDT = 'PST8PDT',
  ATLANTIC_FAEROE = 'Atlantic/Faeroe',
  ASIA_QYZYLORDA = 'Asia/Qyzylorda',
  CANADA_NEWFOUNDLAND = 'Canada/Newfoundland',
  AMERICA_KENTUCKY_LOUISVILLE = 'America/Kentucky/Louisville',
  AMERICA_YAKUTAT = 'America/Yakutat',
  AMERICA_CIUDAD_JUAREZ = 'America/Ciudad_Juarez',
  ASIA_HO_CHI_MINH = 'Asia/Ho_Chi_Minh',
  ANTARCTICA_CASEY = 'Antarctica/Casey',
  EUROPE_COPENHAGEN = 'Europe/Copenhagen',
  AFRICA_ASMARA = 'Africa/Asmara',
  ATLANTIC_AZORES = 'Atlantic/Azores',
  EUROPE_VIENNA = 'Europe/Vienna',
  ROK = 'ROK',
  PACIFIC_PITCAIRN = 'Pacific/Pitcairn',
  AMERICA_MAZATLAN = 'America/Mazatlan',
  AUSTRALIA_QUEENSLAND = 'Australia/Queensland',
  PACIFIC_NAURU = 'Pacific/Nauru',
  EUROPE_TIRANE = 'Europe/Tirane',
  ASIA_KOLKATA = 'Asia/Kolkata',
  SYSTEM_V_MST7 = 'SystemV/MST7',
  AUSTRALIA_CANBERRA = 'Australia/Canberra',
  MET = 'MET',
  AUSTRALIA_BROKEN_HILL = 'Australia/Broken_Hill',
  EUROPE_RIGA = 'Europe/Riga',
  AMERICA_DOMINICA = 'America/Dominica',
  AFRICA_ABIDJAN = 'Africa/Abidjan',
  AMERICA_MENDOZA = 'America/Mendoza',
  AMERICA_SANTAREM = 'America/Santarem',
  KWAJALEIN = 'Kwajalein',
  AMERICA_ASUNCION = 'America/Asuncion',
  ASIA_ULAN_BATOR = 'Asia/Ulan_Bator',
  NZ = 'NZ',
  AMERICA_BOISE = 'America/Boise',
  AUSTRALIA_CURRIE = 'Australia/Currie',
  EST5_EDT = 'EST5EDT',
  PACIFIC_GUAM = 'Pacific/Guam',
  PACIFIC_WAKE = 'Pacific/Wake',
  ATLANTIC_BERMUDA = 'Atlantic/Bermuda',
  AMERICA_COSTA_RICA = 'America/Costa_Rica',
  AMERICA_DAWSON = 'America/Dawson',
  ASIA_CHONGQING = 'Asia/Chongqing',
  EIRE = 'Eire',
  EUROPE_AMSTERDAM = 'Europe/Amsterdam',
  AMERICA_INDIANA_KNOX = 'America/Indiana/Knox',
  AMERICA_NORTH_DAKOTA_BEULAH = 'America/North_Dakota/Beulah',
  AFRICA_ACCRA = 'Africa/Accra',
  ATLANTIC_FAROE = 'Atlantic/Faroe',
  MEXICO_BAJA_NORTE = 'Mexico/BajaNorte',
  AMERICA_MACEIO = 'America/Maceio',
  ETC_UCT = 'Etc/UCT',
  PACIFIC_APIA = 'Pacific/Apia',
  GMT0 = 'GMT0',
  AMERICA_ATKA = 'America/Atka',
  PACIFIC_NIUE = 'Pacific/Niue',
  AUSTRALIA_LORD_HOWE = 'Australia/Lord_Howe',
  EUROPE_DUBLIN = 'Europe/Dublin',
  PACIFIC_TRUK = 'Pacific/Truk',
  MST7_MDT = 'MST7MDT',
  AMERICA_MONTERREY = 'America/Monterrey',
  AMERICA_NASSAU = 'America/Nassau',
  AMERICA_JAMAICA = 'America/Jamaica',
  ASIA_BISHKEK = 'Asia/Bishkek',
  AMERICA_ATIKOKAN = 'America/Atikokan',
  ATLANTIC_STANLEY = 'Atlantic/Stanley',
  AUSTRALIA_NSW = 'Australia/NSW',
  US_HAWAII = 'US/Hawaii',
  SYSTEM_V_CST6 = 'SystemV/CST6',
  INDIAN_MAHE = 'Indian/Mahe',
  ASIA_AQTOBE = 'Asia/Aqtobe',
  AMERICA_SITKA = 'America/Sitka',
  ASIA_VLADIVOSTOK = 'Asia/Vladivostok',
  AFRICA_LIBREVILLE = 'Africa/Libreville',
  AFRICA_MAPUTO = 'Africa/Maputo',
  ZULU = 'Zulu',
  AMERICA_KENTUCKY_MONTICELLO = 'America/Kentucky/Monticello',
  AFRICA_EL_AAIUN = 'Africa/El_Aaiun',
  AFRICA_OUAGADOUGOU = 'Africa/Ouagadougou',
  AMERICA_CORAL_HARBOUR = 'America/Coral_Harbour',
  PACIFIC_MARQUESAS = 'Pacific/Marquesas',
  BRAZIL_WEST = 'Brazil/West',
  AMERICA_ARUBA = 'America/Aruba',
  AMERICA_NORTH_DAKOTA_CENTER = 'America/North_Dakota/Center',
  AMERICA_CAYMAN = 'America/Cayman',
  ASIA_ULAANBAATAR = 'Asia/Ulaanbaatar',
  ASIA_BAGHDAD = 'Asia/Baghdad',
  EUROPE_SAN_MARINO = 'Europe/San_Marino',
  AMERICA_INDIANA_TELL_CITY = 'America/Indiana/Tell_City',
  AMERICA_TIJUANA = 'America/Tijuana',
  PACIFIC_SAIPAN = 'Pacific/Saipan',
  SYSTEM_V_YST9 = 'SystemV/YST9',
  AFRICA_DOUALA = 'Africa/Douala',
  AMERICA_CHIHUAHUA = 'America/Chihuahua',
  AMERICA_OJINAGA = 'America/Ojinaga',
  ASIA_HOVD = 'Asia/Hovd',
  AMERICA_ANCHORAGE = 'America/Anchorage',
  CHILE_EASTER_ISLAND = 'Chile/EasterIsland',
  AMERICA_HALIFAX = 'America/Halifax',
  ANTARCTICA_ROTHERA = 'Antarctica/Rothera',
  AMERICA_INDIANA_INDIANAPOLIS = 'America/Indiana/Indianapolis',
  US_MOUNTAIN = 'US/Mountain',
  ASIA_DAMASCUS = 'Asia/Damascus',
  AMERICA_ARGENTINA_SAN_LUIS = 'America/Argentina/San_Luis',
  AMERICA_SANTIAGO = 'America/Santiago',
  ASIA_BAKU = 'Asia/Baku',
  AMERICA_ARGENTINA_USHUAIA = 'America/Argentina/Ushuaia',
  ATLANTIC_REYKJAVIK = 'Atlantic/Reykjavik',
  AFRICA_BRAZZAVILLE = 'Africa/Brazzaville',
  AFRICA_PORTO_NOVO = 'Africa/Porto-Novo',
  AMERICA_LA_PAZ = 'America/La_Paz',
  ANTARCTICA_DUMONT_D_URVILLE = 'Antarctica/DumontDUrville',
  ASIA_TAIPEI = 'Asia/Taipei',
  ANTARCTICA_SOUTH_POLE = 'Antarctica/South_Pole',
  ASIA_MANILA = 'Asia/Manila',
  ASIA_BANGKOK = 'Asia/Bangkok',
  AFRICA_DAR_ES_SALAAM = 'Africa/Dar_es_Salaam',
  POLAND = 'Poland',
  ATLANTIC_MADEIRA = 'Atlantic/Madeira',
  ANTARCTICA_PALMER = 'Antarctica/Palmer',
  AMERICA_THUNDER_BAY = 'America/Thunder_Bay',
  AFRICA_ADDIS_ABABA = 'Africa/Addis_Ababa',
  ASIA_YANGON = 'Asia/Yangon',
  EUROPE_UZHGOROD = 'Europe/Uzhgorod',
  BRAZIL_DE_NORONHA = 'Brazil/DeNoronha',
  ASIA_ASHKHABAD = 'Asia/Ashkhabad',
  ETC_ZULU = 'Etc/Zulu',
  AMERICA_INDIANA_MARENGO = 'America/Indiana/Marengo',
  AMERICA_CRESTON = 'America/Creston',
  AMERICA_PUNTA_ARENAS = 'America/Punta_Arenas',
  AMERICA_MEXICO_CITY = 'America/Mexico_City',
  ANTARCTICA_VOSTOK = 'Antarctica/Vostok',
  ASIA_JERUSALEM = 'Asia/Jerusalem',
  EUROPE_ANDORRA = 'Europe/Andorra',
  US_SAMOA = 'US/Samoa',
  PRC = 'PRC',
  ASIA_VIENTIANE = 'Asia/Vientiane',
  PACIFIC_KIRITIMATI = 'Pacific/Kiritimati',
  AMERICA_MATAMOROS = 'America/Matamoros',
  AMERICA_BLANC_SABLON = 'America/Blanc-Sablon',
  ASIA_RIYADH = 'Asia/Riyadh',
  ICELAND = 'Iceland',
  PACIFIC_POHNPEI = 'Pacific/Pohnpei',
  ASIA_UJUNG_PANDANG = 'Asia/Ujung_Pandang',
  ATLANTIC_SOUTH_GEORGIA = 'Atlantic/South_Georgia',
  EUROPE_LISBON = 'Europe/Lisbon',
  ASIA_HARBIN = 'Asia/Harbin',
  EUROPE_OSLO = 'Europe/Oslo',
  ASIA_NOVOKUZNETSK = 'Asia/Novokuznetsk',
  CST6_CDT = 'CST6CDT',
  ATLANTIC_CANARY = 'Atlantic/Canary',
  AMERICA_KNOX_IN = 'America/Knox_IN',
  ASIA_KUWAIT = 'Asia/Kuwait',
  SYSTEM_V_HST10 = 'SystemV/HST10',
  PACIFIC_EFATE = 'Pacific/Efate',
  AFRICA_LOME = 'Africa/Lome',
  AMERICA_BOGOTA = 'America/Bogota',
  AMERICA_MENOMINEE = 'America/Menominee',
  AMERICA_ADAK = 'America/Adak',
  PACIFIC_NORFOLK = 'Pacific/Norfolk',
  EUROPE_KIROV = 'Europe/Kirov',
  AMERICA_RESOLUTE = 'America/Resolute',
  PACIFIC_KANTON = 'Pacific/Kanton',
  PACIFIC_TARAWA = 'Pacific/Tarawa',
  AFRICA_KAMPALA = 'Africa/Kampala',
  ASIA_KRASNOYARSK = 'Asia/Krasnoyarsk',
  GREENWICH = 'Greenwich',
  SYSTEM_V_EST5 = 'SystemV/EST5',
  AMERICA_EDMONTON = 'America/Edmonton',
  EUROPE_PODGORICA = 'Europe/Podgorica',
  AUSTRALIA_SOUTH = 'Australia/South',
  CANADA_CENTRAL = 'Canada/Central',
  AFRICA_BUJUMBURA = 'Africa/Bujumbura',
  AMERICA_SANTO_DOMINGO = 'America/Santo_Domingo',
  US_EASTERN = 'US/Eastern',
  EUROPE_MINSK = 'Europe/Minsk',
  PACIFIC_AUCKLAND = 'Pacific/Auckland',
  AFRICA_CASABLANCA = 'Africa/Casablanca',
  AMERICA_GLACE_BAY = 'America/Glace_Bay',
  CANADA_EASTERN = 'Canada/Eastern',
  ASIA_QATAR = 'Asia/Qatar',
  EUROPE_KIEV = 'Europe/Kiev',
  SINGAPORE = 'Singapore',
  ASIA_MAGADAN = 'Asia/Magadan',
  SYSTEM_V_PST8 = 'SystemV/PST8',
  AMERICA_PORT_AU_PRINCE = 'America/Port-au-Prince',
  EUROPE_BELFAST = 'Europe/Belfast',
  AMERICA_ST_BARTHELEMY = 'America/St_Barthelemy',
  ASIA_ASHGABAT = 'Asia/Ashgabat',
  AFRICA_LUANDA = 'Africa/Luanda',
  AMERICA_NIPIGON = 'America/Nipigon',
  ATLANTIC_JAN_MAYEN = 'Atlantic/Jan_Mayen',
  BRAZIL_ACRE = 'Brazil/Acre',
  ASIA_MUSCAT = 'Asia/Muscat',
  ASIA_BAHRAIN = 'Asia/Bahrain',
  EUROPE_VILNIUS = 'Europe/Vilnius',
  AMERICA_FORTALEZA = 'America/Fortaleza',
  US_EAST_INDIANA = 'US/East-Indiana',
  AMERICA_HERMOSILLO = 'America/Hermosillo',
  AMERICA_CANCUN = 'America/Cancun',
  AFRICA_MASERU = 'Africa/Maseru',
  PACIFIC_KOSRAE = 'Pacific/Kosrae',
  AFRICA_KINSHASA = 'Africa/Kinshasa',
  ASIA_KATHMANDU = 'Asia/Kathmandu',
  ASIA_SEOUL = 'Asia/Seoul',
  AUSTRALIA_SYDNEY = 'Australia/Sydney',
  AMERICA_LIMA = 'America/Lima',
  AUSTRALIA_LHI = 'Australia/LHI',
  AMERICA_ST_LUCIA = 'America/St_Lucia',
  EUROPE_MADRID = 'Europe/Madrid',
  AMERICA_BAHIA_BANDERAS = 'America/Bahia_Banderas',
  AMERICA_MONTSERRAT = 'America/Montserrat',
  ASIA_BRUNEI = 'Asia/Brunei',
  AMERICA_SANTA_ISABEL = 'America/Santa_Isabel',
  CANADA_MOUNTAIN = 'Canada/Mountain',
  AMERICA_CAMBRIDGE_BAY = 'America/Cambridge_Bay',
  ASIA_COLOMBO = 'Asia/Colombo',
  AUSTRALIA_WEST = 'Australia/West',
  INDIAN_ANTANANARIVO = 'Indian/Antananarivo',
  AUSTRALIA_BRISBANE = 'Australia/Brisbane',
  INDIAN_MAYOTTE = 'Indian/Mayotte',
  US_INDIANA_STARKE = 'US/Indiana-Starke',
  ASIA_URUMQI = 'Asia/Urumqi',
  US_ALEUTIAN = 'US/Aleutian',
  EUROPE_VOLGOGRAD = 'Europe/Volgograd',
  AMERICA_LOWER_PRINCES = 'America/Lower_Princes',
  AMERICA_VANCOUVER = 'America/Vancouver',
  AFRICA_BLANTYRE = 'Africa/Blantyre',
  AMERICA_RIO_BRANCO = 'America/Rio_Branco',
  AMERICA_DANMARKSHAVN = 'America/Danmarkshavn',
  AMERICA_DETROIT = 'America/Detroit',
  AMERICA_THULE = 'America/Thule',
  AFRICA_LUSAKA = 'Africa/Lusaka',
  ASIA_HONG_KONG = 'Asia/Hong_Kong',
  IRAN = 'Iran',
  AMERICA_ARGENTINA_LA_RIOJA = 'America/Argentina/La_Rioja',
  AFRICA_DAKAR = 'Africa/Dakar',
  SYSTEM_V_CST6_CDT = 'SystemV/CST6CDT',
  AMERICA_TORTOLA = 'America/Tortola',
  AMERICA_PORTO_VELHO = 'America/Porto_Velho',
  ASIA_SAKHALIN = 'Asia/Sakhalin',
  ETC_GMT10 = 'Etc/GMT+10',
  AMERICA_SCORESBYSUND = 'America/Scoresbysund',
  ASIA_KAMCHATKA = 'Asia/Kamchatka',
  ASIA_THIMBU = 'Asia/Thimbu',
  AFRICA_HARARE = 'Africa/Harare',
  ETC_GMT12 = 'Etc/GMT+12',
  ETC_GMT11 = 'Etc/GMT+11',
  NAVAJO = 'Navajo',
  AMERICA_NOME = 'America/Nome',
  EUROPE_TALLINN = 'Europe/Tallinn',
  TURKEY = 'Turkey',
  AFRICA_KHARTOUM = 'Africa/Khartoum',
  AFRICA_JOHANNESBURG = 'Africa/Johannesburg',
  AFRICA_BANGUI = 'Africa/Bangui',
  EUROPE_BELGRADE = 'Europe/Belgrade',
  JAMAICA = 'Jamaica',
  AFRICA_BISSAU = 'Africa/Bissau',
  ASIA_TEHRAN = 'Asia/Tehran',
  WET = 'WET',
  EUROPE_ASTRAKHAN = 'Europe/Astrakhan',
  AFRICA_JUBA = 'Africa/Juba',
  AMERICA_CAMPO_GRANDE = 'America/Campo_Grande',
  AMERICA_BELEM = 'America/Belem',
  ETC_GREENWICH = 'Etc/Greenwich',
  ASIA_SAIGON = 'Asia/Saigon',
  AMERICA_ENSENADA = 'America/Ensenada',
  PACIFIC_MIDWAY = 'Pacific/Midway',
  AMERICA_JUJUY = 'America/Jujuy',
  AFRICA_TIMBUKTU = 'Africa/Timbuktu',
  AMERICA_BAHIA = 'America/Bahia',
  AMERICA_GOOSE_BAY = 'America/Goose_Bay',
  AMERICA_VIRGIN = 'America/Virgin',
  AMERICA_PANGNIRTUNG = 'America/Pangnirtung',
  ASIA_KATMANDU = 'Asia/Katmandu',
  AMERICA_PHOENIX = 'America/Phoenix',
  AFRICA_NIAMEY = 'Africa/Niamey',
  AMERICA_WHITEHORSE = 'America/Whitehorse',
  PACIFIC_NOUMEA = 'Pacific/Noumea',
  ASIA_TBILISI = 'Asia/Tbilisi',
  EUROPE_KYIV = 'Europe/Kyiv',
  AMERICA_MONTREAL = 'America/Montreal',
  ASIA_MAKASSAR = 'Asia/Makassar',
  AMERICA_ARGENTINA_SAN_JUAN = 'America/Argentina/San_Juan',
  HONGKONG = 'Hongkong',
  UCT = 'UCT',
  ASIA_NICOSIA = 'Asia/Nicosia',
  AMERICA_INDIANA_WINAMAC = 'America/Indiana/Winamac',
  SYSTEM_V_MST7_MDT = 'SystemV/MST7MDT',
  AMERICA_ARGENTINA_COMOD_RIVADAVIA = 'America/Argentina/ComodRivadavia',
  AMERICA_BOA_VISTA = 'America/Boa_Vista',
  AMERICA_GRENADA = 'America/Grenada',
  ASIA_ATYRAU = 'Asia/Atyrau',
  AUSTRALIA_DARWIN = 'Australia/Darwin',
  ASIA_KHANDYGA = 'Asia/Khandyga',
  ASIA_KUALA_LUMPUR = 'Asia/Kuala_Lumpur',
  ASIA_FAMAGUSTA = 'Asia/Famagusta',
  ASIA_THIMPHU = 'Asia/Thimphu',
  ASIA_RANGOON = 'Asia/Rangoon',
  EUROPE_BRATISLAVA = 'Europe/Bratislava',
  ASIA_CALCUTTA = 'Asia/Calcutta',
  AMERICA_ARGENTINA_TUCUMAN = 'America/Argentina/Tucuman',
  ASIA_KABUL = 'Asia/Kabul',
  INDIAN_COCOS = 'Indian/Cocos',
  JAPAN = 'Japan',
  PACIFIC_TONGATAPU = 'Pacific/Tongatapu',
  AMERICA_NEW_YORK = 'America/New_York',
  ETC_GMT_12 = 'Etc/GMT-12',
  ETC_GMT_11 = 'Etc/GMT-11',
  AMERICA_NUUK = 'America/Nuuk',
  ETC_GMT_10 = 'Etc/GMT-10',
  SYSTEM_V_YST9_YDT = 'SystemV/YST9YDT',
  EUROPE_ULYANOVSK = 'Europe/Ulyanovsk',
  ETC_GMT_14 = 'Etc/GMT-14',
  ETC_GMT_13 = 'Etc/GMT-13',
  W_SU = 'W-SU',
  AMERICA_MERIDA = 'America/Merida',
  EET = 'EET',
  AMERICA_ROSARIO = 'America/Rosario',
  CANADA_SASKATCHEWAN = 'Canada/Saskatchewan',
  AMERICA_ST_KITTS = 'America/St_Kitts',
  ARCTIC_LONGYEARBYEN = 'Arctic/Longyearbyen',
  AMERICA_FORT_NELSON = 'America/Fort_Nelson',
  AMERICA_CARACAS = 'America/Caracas',
  AMERICA_GUADELOUPE = 'America/Guadeloupe',
  ASIA_HEBRON = 'Asia/Hebron',
  INDIAN_KERGUELEN = 'Indian/Kerguelen',
  SYSTEM_V_PST8_PDT = 'SystemV/PST8PDT',
  AFRICA_MONROVIA = 'Africa/Monrovia',
  ASIA_UST_NERA = 'Asia/Ust-Nera',
  EGYPT = 'Egypt',
  ASIA_SREDNEKOLYMSK = 'Asia/Srednekolymsk',
  AMERICA_NORTH_DAKOTA_NEW_SALEM = 'America/North_Dakota/New_Salem',
  ASIA_ANADYR = 'Asia/Anadyr',
  AUSTRALIA_MELBOURNE = 'Australia/Melbourne',
  ASIA_IRKUTSK = 'Asia/Irkutsk',
  AMERICA_SHIPROCK = 'America/Shiprock',
  AMERICA_WINNIPEG = 'America/Winnipeg',
  EUROPE_VATICAN = 'Europe/Vatican',
  ASIA_AMMAN = 'Asia/Amman',
  ETC_UTC = 'Etc/UTC',
  SYSTEM_V_AST4_ADT = 'SystemV/AST4ADT',
  ASIA_TOKYO = 'Asia/Tokyo',
  AMERICA_TORONTO = 'America/Toronto',
  ASIA_SINGAPORE = 'Asia/Singapore',
  AUSTRALIA_LINDEMAN = 'Australia/Lindeman',
  AMERICA_LOS_ANGELES = 'America/Los_Angeles',
  SYSTEM_V_EST5_EDT = 'SystemV/EST5EDT',
  PACIFIC_MAJURO = 'Pacific/Majuro',
  AMERICA_ARGENTINA_BUENOS_AIRES = 'America/Argentina/Buenos_Aires',
  EUROPE_NICOSIA = 'Europe/Nicosia',
  PACIFIC_GUADALCANAL = 'Pacific/Guadalcanal',
  EUROPE_ATHENS = 'Europe/Athens',
  US_PACIFIC = 'US/Pacific',
  EUROPE_MONACO = 'Europe/Monaco',
}
